import { QueryParams } from 'api/mutations/login.mutation';
import { network } from 'services/network';
import { useMutation } from 'react-query';

const mutationFn = (params: QueryParams) => {
    return network.post('admin/bo/validateLogin', params).then((response) => {
        return response.data;
    });
};
export const useMutationValidateLogin = () => {
    return useMutation<QueryResponse, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryResponse {
    valid: boolean;
}
